<template>
    <div>
    </div>
</template>


<script>
    import {get} from '../util/util'

export default{
    data(){
        return{
            
        }
    },
    created(){
        const queryString = window.location.search;
        const urlParams = new URLSearchParams(queryString);
        const wxCode = urlParams.get('code');
        const aliCode=urlParams.get('auth_code');
        if(wxCode || aliCode){
            let form= window.sessionStorage.getItem("ca_pay_authForm")
            if(form){
                let authForm= JSON.parse(form)
                let code=''
                if(authForm.payType===0)
                    code=wxCode
                if(authForm.payType===1)
                    code=aliCode

                get('QueryPayUser/RequestUserId?authCode='+code+'&payType='+authForm.payType).then(res=>{
                    if(res.code==="1"){
                        authForm.authCode=res.message
                        window.sessionStorage.setItem("ca_pay_authForm",JSON.stringify(authForm))
                        this.CheckCodeType(authForm)
                    }
                })
            }
        }
    },
    methods:{
        CheckCodeType(form){
             get('pp/getcodeinfo?code='+ form.shortParam).then(res=>{
                let pathName=''
                if(res.head.status==="1"){
                    if(res.body.codeType===2){
                        pathName='exitpay'
                    }
                    if(res.body.codeType===1){
                        pathName='enter'
                    }
                    if(res.body.codeType===0){
                        pathName='prepay'
                    }
                    this.$router.push({name:pathName})
                }else{
                    Dialog({ message: res.head.message });
                }
            })
        }
           
    }
}
</script>

<style>

</style>